// Keycloak connection status banner — re-skinned to the FederateX navy palette.
import { Box, Typography, Button, useTheme, keyframes } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { tokens } from "../../../theme";
import { KEYCLOAK_REALM, MONO_FONT } from "../data/mockUsersRoles";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import MenuBookIcon from "@mui/icons-material/MenuBook";

const pulse = keyframes`
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.5); opacity: 0.5; }
`;

const KeycloakBanner = ({ onOpenAdmin }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const accent = colors.secondary[500]; // cyan

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        backgroundColor: "var(--fx-paper)",
        border: `1px solid ${theme.palette.divider}`,
        borderLeft: `3px solid ${accent}`,
        borderRadius: 2,
        p: 1.5,
        px: 2,
        mb: 2.5,
      }}
    >
      <Box
        sx={{
          width: 34,
          height: 34,
          borderRadius: 1.25,
          backgroundColor: "rgba(0,135,180,0.08)",
          border: "1px solid rgba(0,135,180,0.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          color: accent,
        }}
      >
        <ShieldOutlinedIcon sx={{ fontSize: 18 }} />
      </Box>

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={{ fontSize: "0.8125rem", fontWeight: 600, color: 'var(--fx-text-primary)' }}>
          Connected to Keycloak ({" "}
          <Box component="span" sx={{ fontFamily: MONO_FONT, color: accent }}>
            {KEYCLOAK_REALM}
          </Box>{" "}
          realm)
        </Typography>
        <Typography sx={{ fontSize: "0.6875rem", color: colors.grey[500], mt: 0.2 }}>
          Each business runs its own Keycloak; roles created here are mapped into your realm.{" "}
          <Box
            component="span"
            role="link"
            tabIndex={0}
            onClick={() => navigate("/documentation/keycloak-setup")}
            onKeyDown={(e) => e.key === "Enter" && navigate("/documentation/keycloak-setup")}
            sx={{ color: accent, fontWeight: 600, cursor: "pointer",
                  display: "inline-flex", alignItems: "center", gap: 0.3,
                  verticalAlign: "middle", whiteSpace: "nowrap",
                  "&:hover": { textDecoration: "underline" } }}
          >
            <MenuBookIcon sx={{ fontSize: 12 }} /> How to access &amp; set up Keycloak →
          </Box>
        </Typography>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 0.75, flexShrink: 0 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
          <Box
            sx={{
              width: 7,
              height: 7,
              borderRadius: "50%",
              backgroundColor: "#16a34a",
              animation: `${pulse} 2s ease-in-out infinite`,
            }}
          />
          <Typography sx={{ fontFamily: MONO_FONT, fontSize: "0.625rem", color: "#16a34a", fontWeight: 600 }}>
            Connected
          </Typography>
        </Box>
        <Button size="small" variant="outlined" onClick={onOpenAdmin} sx={{ fontSize: "0.6875rem", py: 0.25 }}>
          Open Keycloak Admin →
        </Button>
      </Box>
    </Box>
  );
};

export default KeycloakBanner;
